import script from "./ThankYouCards.vue?vue&type=script&setup=true&lang=js"
export * from "./ThankYouCards.vue?vue&type=script&setup=true&lang=js"

import "./ThankYouCards.vue?vue&type=style&index=0&id=0e4c54c6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e4c54c6"]])

export default __exports__